import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Makhana from "./pages/Makhana";
import Pulses from "./pages/Pulses";
import Quality from "./pages/Quality";
import Packaging from "./pages/Packaging";
import PrivateLabel from "./pages/PrivateLabel";
import ExportMarkets from "./pages/ExportMarkets";
import Certifications from "./pages/Certifications";
import Resources from "./pages/Resources";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import RequestQuotePage from "./pages/RequestQuote";
import Legal from "./pages/Legal";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/makhana" element={<Makhana />} />
            <Route path="/makhana/:slug" element={<ProductDetail />} />
            <Route path="/pulses" element={<Pulses />} />
            <Route path="/pulses/:slug" element={<ProductDetail />} />
            <Route path="/quality" element={<Quality />} />
            <Route path="/packaging" element={<Packaging />} />
            <Route path="/private-label" element={<PrivateLabel />} />
            <Route path="/export-markets" element={<ExportMarkets />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/request-quote" element={<RequestQuotePage />} />
            <Route path="/privacy" element={<Legal kind="privacy" />} />
            <Route path="/terms" element={<Legal kind="terms" />} />
            <Route path="/shipping" element={<Legal kind="shipping" />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
